// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mHUinSEj5NAUG42DdW7t{flex-direction:column;width:100%;display:flex}.sf591lxRCXgZUA6SOr2o{width:100%;height:100%;position:relative}.aJBQL9qJYdQQfnSwdPMl{position:absolute;top:24px;right:20px}.fTQyk9RxUEw2lkyuX_zQ{width:532px;max-width:100%;margin:0 auto;padding:30px 20px}.KeEntGDRBxYAnL1cRJcQ{flex-direction:column;align-items:flex-start;gap:22px;width:-webkit-fit-content;width:fit-content;margin-bottom:33px;display:flex}.KeEntGDRBxYAnL1cRJcQ .hY3bLbN_Ti0VhT4l1k4o{background:var(--gray-a-15);border-radius:4px;padding:3.5px 8px}.UI432zRWjKMXs4T8HuTg{flex-direction:column;gap:24px;display:flex}.pspLuVYBKu03rK5X72z9{flex-direction:column;gap:16px;max-width:400px;display:flex}.YMpOlRf6BUwz_ei6DE3x{margin-top:6px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `mHUinSEj5NAUG42DdW7t`,
	"pageInner": `sf591lxRCXgZUA6SOr2o`,
	"closeButton": `aJBQL9qJYdQQfnSwdPMl`,
	"content": `fTQyk9RxUEw2lkyuX_zQ`,
	"titleWrap": `KeEntGDRBxYAnL1cRJcQ`,
	"title": `hY3bLbN_Ti0VhT4l1k4o`,
	"section": `UI432zRWjKMXs4T8HuTg`,
	"form": `pspLuVYBKu03rK5X72z9`,
	"submitButton": `YMpOlRf6BUwz_ei6DE3x`
};
export default ___CSS_LOADER_EXPORT___;
